// extracted by mini-css-extract-plugin
export default {"suggestedQuestions":"XGd_K0h_Mrdqkd0tfUFm__suggestedQuestions___","title":"WUU1ygGv2kJR82flsjJp__title___","samplePrompt":"iLe5gJvWSN45G8BU2LkN__samplePrompt___"};